module.exports = __webpack_public_path__ + "img/乌镇人民公园2.a8be20e9.jpg";